/* eslint-disable no-restricted-globals */
import { GenerateJWTCyberService } from '../services/GenerateJWTService';
import { CreateLog } from '../services/CreateLogsService';

export async function generate_jwt_cyber(transactionId, order, merchantType) {
    const deviceInfo = {
        httpAcceptContent: navigator.mimeTypes.length ? navigator.mimeTypes[0].type : '',
        httpBrowserLanguage: navigator.language || navigator.userLanguage,
        httpBrowserJavaEnabled: navigator.javaEnabled() ? "Y" : "N",
        httpBrowserJavaScriptEnabled: "Y",
        httpBrowserColorDepth: screen.colorDepth.toString(),
        httpBrowserScreenHeight: screen.height.toString(),
        httpBrowserScreenWidth: screen.width.toString(),
        httpBrowserTimeDifference: (new Date().getTimezoneOffset()).toString(),
        userAgentBrowserValue: navigator.userAgent
    };
    
    const dataToSend = {
        transactionId: transactionId,
        order: order,
        deviceInfo: deviceInfo,
        merchantType:merchantType
    };

    try {
        const json = await GenerateJWTCyberService(dataToSend);
        if (json.accessToken) {
            document.getElementById("cardinal_collection_form_input").value = json.accessToken;
            window.referenceId = json.referenceId;

            var cardinalCollectionForm = document.querySelector('#cardinal_collection_form');
            if (cardinalCollectionForm) {
                cardinalCollectionForm.submit();
            }

            return json.accessToken;
        } else {
            return "";
        }
    }
    catch(err) {
        await CreateLog(transactionId, order, "generate_jwt_api Exception", err.message);
        return "";
    }
}